'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of smoking
 */ const Smoking = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M24.9375 82.9251L24.9375 30.343C24.9375 29.3229 25.7657 28.4947 26.7858 28.4947L35.0122 28.4947C36.0323 28.4947 36.8605 29.3229 36.8605 30.343L36.8605 82.9251C36.8605 83.9452 36.0323 84.7734 35.0122 84.7734L26.7858 84.7734C25.7657 84.7734 24.9375 83.9452 24.9375 82.9251Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M26.6122 24.6361C25.5313 24.6361 24.6562 25.5111 24.6562 26.5921C24.6562 27.673 25.5313 28.5527 26.6122 28.5527L35.1989 28.5527C36.2798 28.5527 37.1595 27.673 37.1595 26.5921C37.1595 25.5111 36.2845 24.6361 35.1989 24.6361L26.6122 24.6361Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M26.6122 24.7617L35.1989 24.7617C36.2798 24.7617 37.1595 23.8867 37.1595 22.8057C37.1595 21.7248 36.2845 20.8451 35.1989 20.8451L26.6122 20.8451C25.5313 20.8451 24.6562 21.7248 24.6562 22.8057C24.6562 23.8867 25.5313 24.7617 26.6122 24.7617Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M21.4304 72.7888H74.0124C75.0325 72.7888 75.8608 73.6171 75.8608 74.6372V82.8635C75.8608 83.8836 75.0325 84.7118 74.0124 84.7118H21.4304C20.4103 84.7118 19.582 83.8836 19.582 82.8635V74.6372C19.582 73.6171 20.4103 72.7888 21.4304 72.7888Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M79.7213 74.4616C79.7213 73.3807 78.8463 72.5056 77.7653 72.5056C76.6844 72.5056 75.8047 73.3807 75.8047 74.4616V83.0482C75.8047 84.1292 76.6844 85.0089 77.7653 85.0089C78.8463 85.0089 79.7213 84.1338 79.7213 83.0482V74.4616Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M79.5977 74.4616V83.0482C79.5977 84.1292 80.4727 85.0089 81.5536 85.0089C82.6346 85.0089 83.5143 84.1338 83.5143 83.0482V74.4616C83.5143 73.3807 82.6346 72.5056 81.5536 72.5056C80.4727 72.5056 79.5977 73.3807 79.5977 74.4616Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.5039 82.5501L40.5039 29.968C40.5039 28.9479 41.3322 28.1197 42.3523 28.1197L50.5786 28.1197C51.5987 28.1197 52.4269 28.9479 52.4269 29.968L52.4269 82.5501C52.4269 83.5702 51.5987 84.3984 50.5786 84.3984L42.3523 84.3984C41.3322 84.3984 40.5039 83.5702 40.5039 82.5501Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M42.1786 24.2611C41.0977 24.2611 40.2227 25.1361 40.2227 26.2171C40.2227 27.298 41.0977 28.1777 42.1786 28.1777L50.7653 28.1777C51.8462 28.1777 52.7259 27.298 52.7259 26.2171C52.7259 25.1361 51.8509 24.2611 50.7653 24.2611L42.1786 24.2611Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M42.1786 24.3789L50.7653 24.3789C51.8462 24.3789 52.7259 23.5039 52.7259 22.4229C52.7259 21.342 51.8509 20.4623 50.7653 20.4623L42.1786 20.4623C41.0977 20.4623 40.2227 21.342 40.2227 22.4229C40.2227 23.5039 41.0977 24.3789 42.1786 24.3789Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3427_20836)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M75.1669 55.7874C72.5531 51.3185 70.7963 46.7534 74.4648 42.5338C78.0816 38.3652 82.9051 33.3497 81.9994 27.3431C81.2456 23.1234 77.4282 20.3934 73.7597 18.8047C79.0846 26.0517 79.8384 28.2861 73.3068 35.485C72.6534 36.1788 71.1975 37.8186 70.5927 38.5124C65.1705 44.6181 67.5807 53.1054 75.1669 55.7874Z",
                        fill: theme.ds5.asset[assetColor]["200"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M79.6785 44.72C80.2317 43.777 81.0341 42.8339 81.7878 41.8398C79.9308 42.3354 78.0707 43.2304 76.7638 44.8191C73.7001 48.5432 76.6118 53.5557 78.9248 56.8323C81.3866 60.1089 80.3806 62.6407 78.3716 65.9654C83.7482 64.9232 85.8575 59.265 82.7938 54.7961C82.493 54.2495 81.6389 53.1593 81.2863 52.6127C79.329 49.6845 77.7212 47.6482 79.6785 44.72Z",
                        fill: theme.ds5.asset[assetColor]["200"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_20836",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "16.5614",
                        height: "47.1579",
                        fill: "white",
                        transform: "translate(67.6562 18.8047)"
                    })
                })
            })
        ]
    });
};

exports.Smoking = Smoking;
//# sourceMappingURL=Smoking.cjs.map
